import { Game } from "./game"

interface Tire {
  id: number
  name: string
  icon: string
}

export const tireMap: Record<Game, Tire[]> = {
  [Game.MK8]: [
    { id: 0, name: "Standard", icon: "standard" },
    { id: 1, name: "Monster", icon: "monster" },
    { id: 2, name: "Roller", icon: "roller" },
    { id: 3, name: "Slim", icon: "slim" },
    { id: 4, name: "Slick", icon: "slick" },
    { id: 5, name: "Metal", icon: "metal" },
    { id: 6, name: "Button", icon: "button" },
    { id: 7, name: "Off-Road", icon: "off_road" },
    { id: 8, name: "Sponge", icon: "sponge" },
    { id: 9, name: "Wood", icon: "wood" },
    { id: 10, name: "Cushion", icon: "cushion" },
    { id: 11, name: "Blue Standard", icon: "blue_standard" },
    { id: 12, name: "Hot Monster", icon: "hot_monster" },
    { id: 13, name: "Azure Roller", icon: "azure_roller" },
    { id: 14, name: "Crimson Slim", icon: "crimson_slim" },
    { id: 15, name: "Cyber Slick", icon: "cyber_slick" },
    { id: 16, name: "Retro Off-Road", icon: "retro_off_road" },
    { id: 17, name: "Gold Tires", icon: "gold_tires" },
    { id: 18, name: "GLA Tires", icon: "gla_tires" },
    { id: 19, name: "Triforce Tires", icon: "triforce_tires" },
    { id: 20, name: "Leaf Tires", icon: "leaf_tires" },
  ],
  [Game.MK8DX]: [
    { id: 0, name: "Standard", icon: "standard" },
    { id: 1, name: "Monster", icon: "monster" },
    { id: 2, name: "Roller", icon: "roller" },
    { id: 3, name: "Slim", icon: "slim" },
    { id: 4, name: "Slick", icon: "slick" },
    { id: 5, name: "Metal", icon: "metal" },
    { id: 6, name: "Button", icon: "button" },
    { id: 7, name: "Off-Road", icon: "off_road" },
    { id: 8, name: "Sponge", icon: "sponge" },
    { id: 9, name: "Wood", icon: "wood" },
    { id: 10, name: "Cushion", icon: "cushion" },
    { id: 11, name: "Blue Standard", icon: "blue_standard" },
    { id: 12, name: "Hot Monster", icon: "hot_monster" },
    { id: 13, name: "Azure Roller", icon: "azure_roller" },
    { id: 14, name: "Crimson Slim", icon: "crimson_slim" },
    { id: 15, name: "Cyber Slick", icon: "cyber_slick" },
    { id: 16, name: "Retro Off-Road", icon: "retro_off_road" },
    { id: 17, name: "Gold Tires", icon: "gold_tires" },
    { id: 18, name: "GLA Tires", icon: "gla_tires" },
    { id: 19, name: "Triforce Tires", icon: "triforce_tires" },
    { id: 20, name: "Leaf Tires", icon: "leaf_tires" },
    { id: 21, name: "Ancient Tires", icon: "ancient_tires" },
  ],
}